/*
Replace
lessonChapter with your resource Name :) Take care about different writings!
/!\ LessonChapter lessonChapter LessonChapters lessonChapters /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const lessonChapterSlice = createSlice({
  name: "lessonChapters",
  initialState: { ...defaultInitialState },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: defaultShowSuccess,
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: defaultAddToDictionary,
  },
});

export const {
  list: listLessonChapters,
  show: showLessonChapter,
  create: createLessonChapter,
  update: updateLessonChapter,
} = lessonChapterSlice.actions;

export const actions = lessonChapterSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const lessonChapters = (state) =>
  state.lessonChapters.idsList.map((id) => state.lessonChapters.dictionary[id]);
export const lessonChapter = (state) =>
  state.lessonChapters.showId &&
  state.lessonChapters.dictionary[state.lessonChapters.showId];
export const lessonChapterAttributes = (state) =>
  lessonChapter(state)?.attributes;
export const lessonChapterRelationships = (state) =>
  lessonChapter(state)?.relationships;
export const lessonChapterId = (state) => state.lessonChapters.showId;

export const getLessonChapter = createSelector(
  (state) => state.lessonChapters.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getLessonChapterAttributes = createSelector(
  (state) => state.lessonChapters.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getLessonChapterRelationships = createSelector(
  (state) => state.lessonChapters.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getLessonChapters = createSelector(
  (state) => state.lessonChapters.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export default lessonChapterSlice.reducer;
